<template>
    <div>
        <refresh :on-refresh="refresh" :refreshing="refreshing"></refresh>
        <loading :loading="loading"></loading>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6" >
                <Logo :logo-type="theType" />
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-11 col-xs-11 col-md-6" v-if="noMessages">
                You do not have any {{typeDesc}}.
            </div>
            <div class="col-11 col-xs-11 col-md-6" v-else>

                <div v-for="message in messages" v-bind:key="message.id" class="bubble">
                    <ion-card-header>
                        <ion-card-subtitle>
                            <ion-chip v-on:click="viewUser(message.message.user_id)">
                                <ion-avatar>
                                    <img :src="message.message.user.avatar" v-if="message.message.user.avatar">
                                    <img src="../assets/ghost-avatar-white-thumb.png" class="dark-img" v-else>
                                </ion-avatar>
                                <ion-label>
                                    {{message.message.user.name}}
                                </ion-label>
                            </ion-chip>
                            <br>
                            {{dateFormat(message.message.send_at, 'Do MMMM YYYY')}}
                        </ion-card-subtitle>
                        <ion-card-title>
                            {{message.message.title}}
                        </ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <div v-if="theType =='audio'">
                            <audio controls style="width:100%;">
                                <source :src="message.message.path" :type="message.message.mime">
                                Your browser does not support the audio tag.
                            </audio>
                        </div>
                        <div v-else-if="theType =='video'">
                            <video controls style="width:100%;" poster="/img/icons/videos-blue.png">
                                <source :src="message.message.path" :type="message.message.mime">
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        <div v-else-if="theType =='image'">
                            <ion-img :src="message.message.path"></ion-img>
                        </div>
                        <div v-else>
                            <div v-html="nl2br(message.message.message)"></div>
                        </div>
                        <div v-if="!message.viewed_at" v-observe-visibility="(isVisible, entry) => viewed(isVisible, entry, message)"></div>
                    </ion-card-content>
                </div>
            </div>
        </div>
        <ion-infinite-scroll @ionInfinite="loadMore" threshold="100px" position="bottom">
            <ion-infinite-scroll-content loading-spinner="dots"></ion-infinite-scroll-content>
        </ion-infinite-scroll>
       <return-home v-if="complete || noMessages"></return-home>
    </div>
</template>

<script>
import {auth} from '../mixins/auth';
import {userdetails} from '../mixins/userdetails';
import {formatting} from '../mixins/formatting';
import ReturnHome from '@/components/ReturnHome.vue';
import Refresh from '@/components/Refresh.vue';
import Loading from '@/components/Loading.vue';
import Logo from '@/components/Logo.vue';
import _ from 'lodash';

export default {
    props : {
        theType : String
    },
    mounted : function () {
        this.getMessages();
    },
    mixins : [auth, userdetails, formatting],
    components : {
        ReturnHome, Logo, Refresh, Loading
    },
    data : function () {
        return {
            messages : [],
            page     : 1,
            complete : false,
            loading  : false,
            refreshing : false
        }
    },
    computed : {
        typeTitle : function () {
            if (this.theType == 'audio') { return 'Calls'; }
            if (this.theType == 'video') { return 'Videos'; }
            if (this.theType == 'image') { return 'Gallery'; }
            return 'Messages';
        },
        typeDesc : function () {
            if (this.theType == 'audio') { return 'calls'; }
            if (this.theType == 'video') { return 'videos'; }
            if (this.theType == 'image') { return 'photos'; }
            return 'messages';
        },
        noMessages : function () {
            return _.size(this.messages) == 0;
        }
    },
    methods : {
        refresh : function () {
            this.refreshing = true;
            this.page = 1;
            this.getMessages();
        },
        hideLoading : function () {
            this.loading = false;
            this.refreshing = false;
        },
        loadMore : function (event) {
            // console.log('loading messages', event);
            this.getMessages();
            event.target.complete();
        },
        getMessages : function () {
            let self = this;
            if (this.complete) {
                this.hideLoading();
                return;
            }
            this.loading = true;
            this.axios.get(this.api + 'messages/inbox/' + this.theType + '?page=' + this.page)
                .then(response => {
                    if (self.refreshing) {
                        self.messages = [];
                        self.refreshing = false;
                    }

                    var messages = _.reverse(_.sortBy(response.data, ['send_at']));
                    self.hideLoading();
                    if (_.size(messages) > 0) {
                        _.each(messages, function (message) {
                            self.messages.push(message);
                        });
                        self.page = self.page + 1;
                    } else {
                        self.complete = true;
                    }
                })
                .catch(error => {
                    console.error('Error getting messages', error);
                    self.hideLoading();
                });
        },
        viewed : function (isVisible, entry, message) {

            console.log('MESSAGE', message);
            if (isVisible && !message.viewed_at) {
                this.axios.post(this.api + 'messages/' + message.message_id + '/viewed')
                    .then(() => {
                        message.viewed_at = true;
                    })
                    .catch(error => {
                        console.error('Error setting message as viewed', error);
                    })
            }
        },
        viewUser : function (id) {
            this.$router.push({name : 'user', params : {id : id}});
        },
        back : function () {
            this.$router.push({name : 'home'});
        }
    }
}
</script>